import React, { useEffect, useState } from 'react';
import { Modal, Row, Col, Card, Typography, message } from 'antd';
import { GetTimeJavamons } from "../../../../dao/jutge/GetTimeJavamons";
import { getJavamonImage } from "../../../../dao/jutge/GetJavamonConfig";

const { Text } = Typography;

interface Props {
    visible: boolean;
    onClose: () => void;
    onSelect: (idJavamon: string) => void;
    userId: string;
}

const SelectJavamonTimeModal: React.FC<Props> = ({ visible, onClose, onSelect, userId }) => {
    const [javamons, setJavamons] = useState<any[]>([]);

    useEffect(() => {
        if (visible) {
            GetTimeJavamons(userId).then(setJavamons);
        }
    }, [visible, userId]);

    const javamonImage = (jm: any) => {
        return getJavamonImage(jm);
    }

    return (
        <Modal
            title="Selecciona un Javamon de Tiempo"
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <Row gutter={[16, 16]}>
                {javamons.map(j => (
                    <Col span={8} key={j.id}>
                        <Card
                            hoverable
                            onClick={() => onSelect(j.id)}
                            cover={
                                <img
                                    alt={j.nom}
                                    src={javamonImage(j)}
                                    style={{ height: 100, objectFit: 'contain', padding: 10 }}
                                />
                            }
                        >
                            <Card.Meta title={j.nom} description={j.descr} />
                        </Card>
                    </Col>
                ))}
                {javamons.length === 0 && <Text>No tienes Javamons de tiempo disponibles.</Text>}
            </Row>
        </Modal>
    );
};

export default SelectJavamonTimeModal;
